import React, { useEffect, useMemo, useState } from 'react';
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";
import ReportUtils from "../../../../../utils/report-utils.js";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const ReportContent = ({ data }) => {
    if (!data) return null;

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Importância do ponto de coleta`, "collection-point-data");
    }, [data]);

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(data.capturePlace);

    return (
        <>
            <div className="mb-2 mt-[-7px]"><h2>Total de passagens: {data.amount}</h2></div>
            <table id="collection-point-data" className="table report-table" sheet-name="Importância do ponto de coleta">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th onClick={() => handleSort('description')} style={{ cursor: 'pointer', width: '36%' }}>Ponto de coleta {getIcon(order, 'description')}</th>
                        <th onClick={() => handleSort('reading_total')} style={{ cursor: 'pointer', width: '9%' }}>Passagens {getIcon(order, 'reading_total')}</th>
                        <th onClick={() => handleSort('processing_percentage')} style={{ cursor: 'pointer', width: '9%' }}>Passagens (%) {getIcon(order, 'processing_percentage')}</th>
                        <th onClick={() => handleSort('alarm_total')} style={{ cursor: 'pointer', width: '7%' }}>Alarmes {getIcon(order, 'alarm_total')}</th>
                        <th onClick={() => handleSort('total_monitoring')} style={{ cursor: 'pointer', width: '12%' }}>Acompanhamentos {getIcon(order, 'total_monitoring')}</th>
                    </tr>
                </thead>

                <tbody className="bg-white">
                    { sortedData.map((element, index) => (
                        <tr key={index} className="table-break-word">
                            <td>{element.description}</td>
                            <td>{element.reading_total}</td>
                            <td>{element.processing_percentage}%</td>
                            <td>{element.alarm_total}</td>
                            <td>{element.total_monitoring}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="mt-4">
                <h3>Legenda</h3>
                <ul className="list-disc pl-5">
                    <li><strong>Passagens: </strong>Total de passagens no ponto de coleta no período selecionado</li>
                    <li><strong>Passagens (%): </strong>Indica qual a porcentagem de passagens que o ponto de coleta representa em relação ao total de passagens geral no período</li>
                    <li><strong>Alarme: </strong>Total de alarmes no ponto de coleta no período selecionado</li>
                    <li><strong><FaChevronUp className="inline"/>: </strong>Indica que a tabela está em ordem crescente baseada no campo em que o ícone está</li>
                    <li><strong><FaChevronDown className="inline"/>: </strong>Indica que a tabela está em ordem decrescente baseada no campo em que o ícone está</li>
                </ul>
            </div>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;